import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Rocket, PowerOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { EmptyState } from "@/components/ui/EmptyState";
import { useSelectedModel } from "@/hooks/useSelectedModel";
import { useModels } from "@/hooks/useModels";

export const ModelDeployment = () => {
  const { model } = useSelectedModel();
  const { deployModel } = useModels();

  const isDeployed = model?.deployment_status === "deployed";

  const toggle = async () => {
    if (!model) return;
    await deployModel.mutateAsync({ id: model.id, deploy: !isDeployed });
    toast.success(isDeployed ? "Model taken offline" : "Model is live");
  };

  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 mb-6">
        <Rocket className="h-5 w-5" />
        <h2 className="text-xl font-semibold">Put it to work</h2>
      </div>

      {!model ? (
        <EmptyState
          icon={Rocket}
          title="Nothing to deploy yet"
          description="Train a model first — then you can switch it live for your workflows."
        />
      ) : (
        <div className="space-y-4">
          <div className="flex flex-wrap items-center gap-3">
            <span className="font-medium">{model.name}</span>
            <Badge variant={isDeployed ? "default" : "secondary"}>
              {isDeployed ? "Live" : "Offline"}
            </Badge>
            {model.deployed_at && (
              <span className="text-xs text-muted-foreground">
                since {new Date(model.deployed_at).toLocaleString()}
              </span>
            )}
          </div>

          <Button onClick={toggle} disabled={deployModel.isPending} className="w-full md:w-auto">
            {deployModel.isPending ? (
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            ) : isDeployed ? (
              <PowerOff className="h-4 w-4 mr-2" />
            ) : (
              <Rocket className="h-4 w-4 mr-2" />
            )}
            {isDeployed ? "Take offline" : "Make this model live"}
          </Button>
        </div>
      )}
    </Card>
  );
};
